export const WIZARD_NAME = 'Stroomnet Checker';
